<div style="display: flex">
	<!-- Left Button -->
	<button
		mat-button
		class="data-set-action-group"
		[ngClass]="{
			'data-set-action-group-toggle-active': isLeftButtonSelected,
			'data-set-action-group-toggle-inactive': !isLeftButtonSelected,
		}"
		(click)="onSelection(ButtonSelected.left)"
		data-automation-id="show-whitelist-devices-button"
	>
		<mat-icon [svgIcon]="isLeftButtonSelected ? activeLeftButtonIcon : inactiveLeftButtonIcon"></mat-icon>
	</button>

	<!-- Right Button -->
	<button
		mat-button
		class="data-set-action-group"
		[ngClass]="{
			'data-set-action-group-toggle-active': isRightButtonSelected,
			'data-set-action-group-toggle-inactive': !isRightButtonSelected,
		}"
		(click)="onSelection(ButtonSelected.right)"
		data-automation-id="show-whitelist-users-button"
	>
		<mat-icon [svgIcon]="isRightButtonSelected ? activeRightButtonIcon : inactiveRightButtonIcon"></mat-icon>
	</button>
</div>
